(function () {
  'use strict';
  class KymikoGallery {
    constructor() {
      const dataEl = document.querySelector('[id^="kymiko-variant-media-"]');
      if (!dataEl) return;
      this.data = JSON.parse(dataEl.textContent);
      this.sectionId = this.data.sectionId;
      this.variantMediaMap = {};
      this.galleryMain = document.querySelector('.kymiko-gallery-main .proFeaturedImage');
      this.thumbStrip = document.getElementById('kymikoThumbs');
      if (!this.galleryMain || !this.thumbStrip) return;
      if (!this.data.hasOnlyDefaultVariant) this.buildVariantMediaMap();
      this.setupThumbnailClicks();
      this.setupVariantListener();
      this.applyInitialVariant();
    }
    buildVariantMediaMap() {
      const allItems = Array.from(this.galleryMain.querySelectorAll('.item'));
      const variantsWithSku = this.data.variants.filter(v => v.sku);
      if (variantsWithSku.length >= 2) {
        let matched = 0;
        allItems.forEach(item => {
          const src = (item.dataset.pswpSrc || '').toUpperCase();
          for (const variant of variantsWithSku) {
            if (src.includes(variant.sku.toUpperCase())) {
              if (!this.variantMediaMap[variant.id]) this.variantMediaMap[variant.id] = [];
              this.variantMediaMap[variant.id].push(item.dataset.mediaId);
              matched++;
              break;
            }
          }
        });
        if (matched > 0) return;
      }
      const variants = this.data.variants.filter(v => v.featuredMediaPosition !== null);
      if (variants.length < 2) return;
      variants.sort((a, b) => a.featuredMediaPosition - b.featuredMediaPosition);
      variants.forEach((variant, i) => {
        const startIdx = variant.featuredMediaPosition - 1;
        const endIdx = variants[i + 1] ? variants[i + 1].featuredMediaPosition - 1 : allItems.length;
        this.variantMediaMap[variant.id] = allItems.slice(startIdx, endIdx).map(el => el.dataset.mediaId);
      });
    }
    filterGallery(variantId) {
      const allowed = this.variantMediaMap[variantId];
      if (!allowed || allowed.length === 0) return;
      const allowedSet = new Set(allowed);
      this.galleryMain.querySelectorAll('.item').forEach(el => {
        if (allowedSet.has(el.dataset.mediaId)) el.classList.remove('kymiko-hidden', 'act');
        else { el.classList.add('kymiko-hidden'); el.classList.remove('act'); }
      });
      this.thumbStrip.querySelectorAll('.thumbItem').forEach(el => {
        if (allowedSet.has(el.dataset.mediaId)) el.classList.remove('kymiko-hidden', 'active');
        else { el.classList.add('kymiko-hidden'); el.classList.remove('active'); }
      });
      this.setActiveMedia(allowed[0]);
    }
    setActiveMedia(mediaId) {
      this.galleryMain.querySelectorAll('.item').forEach(el => {
        el.classList.toggle('act', el.dataset.mediaId === mediaId);
      });
      this.thumbStrip.querySelectorAll('.thumbItem').forEach(el => {
        el.classList.toggle('active', el.dataset.mediaId === mediaId);
      });
    }
    setupThumbnailClicks() {
      this.thumbStrip.addEventListener('click', e => {
        const thumbItem = e.target.closest('.thumbItem');
        if (!thumbItem) return;
        e.preventDefault();
        const mediaId = thumbItem.dataset.mediaId;
        if (!mediaId) return;
        this.setActiveMedia(mediaId);
      });
    }
    setupVariantListener() {
      const variantInput = document.getElementById('variant_id');
      if (!variantInput) return;
      variantInput.addEventListener('change', e => {
        const newId = parseInt(e.target.value, 10);
        if (newId && this.variantMediaMap[newId]) this.filterGallery(newId);
      });
    }
    applyInitialVariant() {
      const variantInput = document.getElementById('variant_id');
      if (!variantInput) return;
      const variantId = parseInt(variantInput.value, 10);
      if (variantId && this.variantMediaMap[variantId]) this.filterGallery(variantId);
    }
  }
  function boot() { if (document.querySelector('.template-product')) new KymikoGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
